// @core/api/endpoints/calendar/delete_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/calendar';

/**
 * Delete event
 * Permanently deletes an event and notifies all attendees. For recurring events, use DeleteRecurringEventOccurrence to delete a single occurrence.
 */
export async function DeleteEvent(
  event_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/events/:event_id`;
  requestPath = requestPath.replace(':event_id', encodeURIComponent(event_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
